export default "__VITE_ASSET__DyOTBkJ$__"